export let RsvpStatus = /*#__PURE__*/function (RsvpStatus) {
  RsvpStatus["GOING"] = "GOING";
  RsvpStatus["NOT_GOING"] = "NOT_GOING";
  RsvpStatus["WAITLIST"] = "WAITLIST";
  return RsvpStatus;
}({});
//# sourceMappingURL=constants.js.map